import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const lanesLookupAdapter = getAdapter({ idFieldName: 'quoteLaneId' });

const lanesLookupSlice = createSlice({
  name: 'lanesLookup',
  initialState: lanesLookupAdapter.getInitialState(),
  reducers: {
    setLanesLookup: (state, { payload: { lanesLookup } }) => {
      lanesLookupAdapter.setAll(state, lanesLookup);
    },
  },
});

const selectors = lanesLookupAdapter.getSelectors(({ lanesLookup }) => lanesLookup);

export const getLanesLookup = (state) => selectors.selectAll(state);

export const {
  setLanesLookup,
} = lanesLookupSlice.actions;

export default lanesLookupSlice.reducer;